import apiClient from './apiClient';
import { Banner } from '../structures/response/Banner';

export const bannerList = (): Promise<Banner[]> =>
  apiClient.get('banner/default/list').then((r) => r.data);
